import { FooterLinkSection } from './footer-link-section';
import { FooterTextSection } from './footer-text-section';
import { FooterImageSection } from './footer-image-section';
import { FooterButtonSection } from './footer-button-section';
export var sectionTypes = new Map([['links', FooterLinkSection], ['text', FooterTextSection], ['img', FooterImageSection], ['buttons', FooterButtonSection]]);
export function isValidSectionData(sectionData) {
  var textContent = sectionData && sectionData.text;
  var imgContentSrc = sectionData && sectionData.imgSrc;
  if (!textContent && !imgContentSrc) {
    return false;
  }
  if (textContent && textContent.length >= 1) {
    return true;
  }
  if (imgContentSrc && imgContentSrc.length >= 1) {
    return true;
  }
  return false;
}
export function isValidSection(section) {
  if (!section || !section.sectionData || section.sectionData.length <= 0) {
    return false;
  }
  var sectionDataList = section.sectionData;
  if (sectionDataList.find(isValidSectionData)) {
    return true;
  }
}
export function setMinimalSectionData(section) {
  return section.templateRegionId !== 'minimalLinks' && section.type !== 'buttons' && section.type !== 'separator' && section.templateRegionId !== 'legalLinks';
}
export function setSectionData(section) {
  return section.templateRegionId !== 'minimalLinks';
}